export enum FieldTypeEnum {
  PlainValue = "PlainValue",
  KeyValue = "KeyValue",
  NestedObjectAsRelation = "NestedObjectRelation",
  NestedEntity = "NestedEntity",
}

export enum OptionTypeEnum {
  StaticData = "StaticData",
  Enum = "Enum",
  Entity = "Entity",
  List = "List",
  SpecialPurpose = "SpecialPurpose",
}

export enum ClassValidatorTypeEnum {
  Array = "Array",
  Boolean = "Boolean",
  Date = "Date",
  Enum = "Enum",
  Number = "Number",
  Object = "Object",
  String = "String",
  Url = "Url",
  Email = "Email",
  Any = "Any",
}
